import { mapFillStyleTo } from '@ff-os/rendering-shared/coloring';
import { PaintTarget } from '@ff-os/rendering-shared/targets';
import { Json } from '@ff-os/shared-json/Json';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { Paintable } from 'ff-canvas';
import { PaintablesVariableInput } from './PaintablesVariableInput';
import { PaintablesVariableOptions } from './PaintablesVariableOptions';

export const paintablesToFfCanvas = (
    variable: GiftJson.Variable<PaintablesVariableOptions>,
    input: PaintablesVariableInput,
    palette: Json.Palette,
    target: PaintTarget,
    jwt: string | null
): Paintable[] => {

    return variable.options.paintables.map(p => {

        if (!hasFillStyle(p)) {
            return p;
        }

        return {
            ...p,
            fillStyle: mapFillStyleTo(target, p, variable.options, palette)
        };
    });
};

const hasFillStyle = (p: Paintable): p is Paintable & { fillStyle: string } => {
    return 'fillStyle' in p;
};